import React, { useEffect, useState } from 'react';
import { RootStateOrAny, useDispatch, useSelector } from 'react-redux';
import {
  clearCommodities,
  clearSingleCommodity,
  getCommodities,
  getCommodityGroups,
  getCommodityTranslation,
  getSingleCommodity,
} from '../../redux/actions/commodityGroupsActions';
import { selectCommoditiesBySubType } from '../../redux/selectors/commoditiesSelector';
import CommoditiesTable from './CommoditiesTable';
import CommodityDetailsDialog from '../CommoditiyDetailsDialog/CommodityDetailsDialog';

/**
 * Table on commodities tab.
 * @constructor
 */
const CommoditiesTab = () => {
  const dispatch: any = useDispatch();
  const selectedBrand = useSelector(
    (state: RootStateOrAny) => state.UIReducer.selectedBrand,
  );
  const { thisUser } = useSelector(
    (state: RootStateOrAny) => state.UserReducer,
  );
  const commodityGroups = useSelector(
    (state: RootStateOrAny) => state.CommodityGroupsReducer.commodityGroups,
  );
  const [OpenCommodityTranslation, setOpenCommodityTranslation] =
    useState(false);
  const [CommoditySelected, setCommoditySelected] = useState(null);

  const commodities = useSelector((state: RootStateOrAny) =>
    selectCommoditiesBySubType(state),
  );
  const searchReduxObject = useSelector(
    (state: RootStateOrAny) => state.EquipmentsReducer.searchObject,
  );
  const [searchObject, setSearchObject] = useState<any>({
    commodity: '',
  });

  /**
   * Validation for brand change, also verifies if user has access to commodities table.
   */
  useEffect(() => {
    if (selectedBrand) {
      if (thisUser.hasViewCommodities) {
        dispatch(getCommodityGroups({ brand: selectedBrand }));
      }
    }
  }, [selectedBrand]);

  /**
   * Gets the commodities with or without a filter.
   * @param commoditySubType receives a subtype of commodities to filter.
   */
  const fetchCommodities = commoditySubType => {
    dispatch(
      getCommodities(
        {
          brand: selectedBrand,
          ...searchReduxObject,
          commodity: searchObject.commodity,
        },
        commoditySubType,
      ),
    );
  };
  //This opens a detailed view of each commoditie acording to the id that receives
  const [detailsModalOpen, setDetailsModalOpen] = useState(false);
  const showDetailCommodity =
    (commoditySubTypeId, commodityId) => async event => {
      await dispatch(getCommodityTranslation(commodityId, selectedBrand));
      await dispatch(
        getSingleCommodity(commoditySubTypeId, commodityId, {
          brand: selectedBrand,
        }),
      );
      setDetailsModalOpen(true);
    };
  const handleCloseTranslationModal = () => {
    setOpenCommodityTranslation(false);
  };
  const handleClose = () => {
    setDetailsModalOpen(false);
    dispatch(clearSingleCommodity());
  };

  const handleChangeAutocomplete = (event: any) => {
    setSearchObject({
      ...searchObject,
      [event.target.name]: event.target.value ? event.target.value : '',
    });
  };
  /**
   * Handles when appling filters to table.
   */
  const handleApplyButton = () => {
    dispatch(
      getCommodityGroups({
        brand: selectedBrand,
        ...searchReduxObject,
        commodity: searchObject.commodity,
      }),
    );
    dispatch(clearCommodities());
  };

  return (
    <div>
      <CommoditiesTable
        commodityGroups={commodityGroups}
        commodities={commodities}
        searchObject={searchObject}
        handleChangeAutocomplete={handleChangeAutocomplete}
        handleApplyButton={handleApplyButton}
        fetchCommodities={fetchCommodities}
        showDetailCommodity={showDetailCommodity}
      />
      <CommodityDetailsDialog
        open={detailsModalOpen}
        handleOpen={showDetailCommodity}
        handleClose={handleClose}
        handleCloseTranslationModal={handleCloseTranslationModal}
        OpenCommodityTranslation={OpenCommodityTranslation}
        CommoditySelected={CommoditySelected}
      />
    </div>
  );
};

export default CommoditiesTab;
